import React from 'react';
import classNames from 'classnames';

import css from './IconMap.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconMap = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg 
    className={classes}
    width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.581 29.5385L2.80363 31.3477C1.37033 31.6811 0 30.5931 0 29.1216V4.27655C0 3.21371 0.732603 2.29111 1.7678 2.05028L10.581 0V29.5385Z"
        fill="#ACCABB"
      />
      <path d="M10.5801 29.5385L21.4181 32V2.46153L10.5801 0V29.5385Z" fill="#13472E" />
      <path
        d="M32.001 27.7232C32.001 28.7861 31.2684 29.7086 30.2332 29.9495L21.4199 31.9998V2.46131L29.1973 0.652003C30.6307 0.318565 32.001 1.4067 32.001 2.87827V27.7232Z"
        fill="#ACCABB"
      />
    </svg>
  );
};

export default IconMap;